import tw from 'tailwind-styled-components'

const StatusContainer = tw.div`
flex
flex-col
`

const Content = tw.div`
flex
items-center
gap-2
`

const LastAccess = tw.span`
text-xs
font-light
text-darkGray
`

export { StatusContainer, Content, LastAccess }
